import styled, { css } from 'styled-components'

export const NotificationWrapper = styled.div`
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
`
export const NotificationHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`
export const NotificationItem = styled.div`
	margin: 0 10px 0 12px;
	width: 100%;
`
export const NotificationTitle = styled.div`
	font-weight: bold;
`
export const NotificationText = styled.div`
	margin-left: 12px;
	margin-right: 12px;
`
export const NotificationBody = styled.div<{ hasTitle?: boolean }>`
	${({ hasTitle }) =>
		hasTitle &&
		css`
			margin-top: 8px;
		`}
`
export const NotificationFooter = styled.div`
	margin-top: 8px;
`

export const DisplayFlex = styled.div`
	display: flex;
`
